import { CallOnShow, CallOnShowRaw } from '~/components/calls/types'

export const convertCall = (call: CallOnShowRaw): CallOnShow => {
  return {
    ...call,
    createdAt: new Date(call.createdAt),
  }
}
